import { RouteRecordRaw } from "vue-router";
import { guardAdmin, guardAdminIOSI, guardClient, guardUserClient } from "./guards";
import OrganizationsVue from '@/views/Organizations/ListOrganizations.vue'
import AddOrganizationVue from '@/views/Organizations/AddOrganization.vue'
import ComputersVue from '@/views/Computers/ListComputers.vue'
import AddComputerVue from '@/views/Computers/AddComputer.vue'
import LicensesVue from '@/views/Licenses/ListLicenses.vue'
import AddLicenseVue from '@/views/Licenses/AddLicense.vue'
import GroupsVue from '@/views/Groups/ListGroups.vue'
import AddGroupVue from '@/views/Groups/AddGroup.vue'
import AddGroupOrganization from '@/views/Groups/GroupOrganization.vue'
import ListUsersVue from '@/views/Users/ListUsers.vue'
import AddUserVue from '@/views/Users/AddUser.vue'
import ListSchedule from '@/views/Schedule/ListSchedule.vue'
import AddSchedule from '@/views/Schedule/AddSchedule.vue'
import ProfileVue from '@/views/Profile/Profile.vue'
import ScheduleClient from '@/views/ScheduleClient/ListScheduleClient.vue'
import AddScheduleClient from '@/views/ScheduleClient/AddScheduleClient.vue'
import BuyCredits from '@/views/ScheduleClient/BuyCredits/BuyCredits.vue'
import PaymentHistory from '@/views/ScheduleClient/PaymentHistory/PaymentHistory.vue'
import ListCoupons from '@/views/Coupom/ListCoupons.vue'
import TutorialAnydesk from '@/views/tutorialAnydesk/tutorial-anydesk.vue'
import TutorialRustDesk from "@/views/tutorialRustdesk/tutorial-rustdesk.vue";
export const authenticatedRoutes: Array<RouteRecordRaw> = [
    {
        path: '/organizations',
        name: 'Organizations',
        component: OrganizationsVue,
        beforeEnter: guardAdminIOSI,
        meta: { auth: true }
      },
      {
        path: '/organizations/add',
        name: 'AddOrganization',
        component: AddOrganizationVue,
        beforeEnter: guardAdminIOSI,
        meta: { auth: true }
      },
      {
        path: '/organizations/:id',
        name: 'editOrganization',
        component: AddOrganizationVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/computers',
        name: 'Computers',
        component: ComputersVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/computers/add',
        name: 'AddComputer',
        component: AddComputerVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/computers/:id',
        name: 'editComputer',
        component: AddComputerVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/licenses',
        name: 'Licenses',
        component: LicensesVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/licenses/add',
        name: 'AddLicense',
        component: AddLicenseVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/licenses/:id',
        name: 'editLicense',
        component: AddLicenseVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/groups',
        name: 'Groups',
        component: GroupsVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/groups/add',
        name: 'AddGroup',
        component: AddGroupVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/groups/:id',
        name: 'editGroup',
        component: AddGroupVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/groups/:id/add-organization/',
        name: 'addGroupOrganization',
        component: AddGroupOrganization,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/users',
        name: 'Users',
        component: ListUsersVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/users/add',
        name: 'AddUser',
        component: AddUserVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/users/:id',
        name: 'editUser',
        component: AddUserVue,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: ProfileVue,
        meta: { auth: true }
      },
      {
        path: '/schedule',
        name: 'Schedule',
        component: ListSchedule,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/schedule/add',
        name: 'AddSchedule',
        component: AddSchedule,
        beforeEnter: guardAdmin,
        meta: { auth: true }
      },
      {
        path: '/schedule/:id',
        name: 'editSchedule',
        beforeEnter: guardAdmin,
        component: AddSchedule,
        meta: { auth: true }
      },
      {
        path: '/agendamento',
        name: 'ScheduleClient',
        component: ScheduleClient,
        beforeEnter: guardUserClient,
        meta: { auth: true }
      },
      {
        path: '/agendamento/adicionar',
        name: 'AddScheduleClient',
        component: AddScheduleClient,
        beforeEnter: guardUserClient,
        meta: { auth: true }
      },
      {
        path: '/agendamento/:id',
        name: 'EditScheduleClient',
        component: AddScheduleClient,
        beforeEnter: guardUserClient,
        meta: { auth: true }
      },
      {
        path: '/comprar-horas',
        name: 'BuyCredits',
        component: BuyCredits,
        beforeEnter: guardUserClient,
        meta: { auth: true }
      },
      {
        path: '/historico-pagamentos',
        name: 'PaymentHistorys',
        component: PaymentHistory,
        beforeEnter: guardUserClient,
        meta: { auth: true }
      },
      {
        path: '/start-mac/:id?',
        name: 'TutorialRustDesk',
        component: TutorialRustDesk,
        beforeEnter: guardUserClient,
        meta: { auth: true }
      },
      {
        path: '/coupons',
        name: 'ListCoupons',
        component: ListCoupons,
        meta: { auth: true },
        beforeEnter: guardAdminIOSI,
      }
]

